import React, { useState, useRef, useContext } from 'react';

import './Navbar.css'
import {Link} from 'react-router-dom'

import logo from '../Assets/logo.png'
import cart from '../Assets/cart_icon.png'

// import { ShopContext } from '../../Context/ShopContext';
import nav_dropdown from '../Assets/down-arrow.png'
import { ShopContext } from '../../Context/ShopContext';

const Navbar = () => {
    const {cartItems} = useContext(ShopContext);
    const [menu, setMenu] = useState("")
//     const {getTotalCartItems} = useContext(ShopContext) 
    const menuRef = useRef();
    const [DropDownOpen, setDropDownOpen] = useState(false);
    const totalCartItems = Object.values(cartItems).reduce((sum, quantity) => sum + quantity, 0);


    const handleItemClick = (item) => {
        setMenu(item);   // Set selected item
        setDropDownOpen(false);  // Close dropdown
        menuRef.current.classList.remove('nav-menu-visible');  // Hide the menu
    };
    

    const dropdown_toggle = (e) =>{
          menuRef.current.classList.toggle('nav-menu-visible');
         e.target.classList.toggle('open');
}
    return(
        <div className = "navbar">
           <div className = 'nav-logo'>
               
                   
                   <Link to = '/'  onClick={()=> {handleItemClick("shop")}}  > <img src = {logo} alt="#" /> </Link> 
                
           </div>
           {/* <img className='nav-dropdown' onClick={dropdown_toggle} src={nav_dropdown} alt="" /> */}
           <ul ref = {menuRef} className="nav-menu" >
                <li  onClick={()=> {handleItemClick("shop")}}> <Link style = {{textDecoration:"None", color:"rgb(14, 13, 13)"}} to = '/' >Shop</Link>          {menu==="shop"?        <hr/> : <></> } </li>
                <li onClick={()=> {handleItemClick("mens")}}> <Link style = {{textDecoration:"None", color:"rgb(7, 7, 7)"}} to = '/men' >Men</Link>         {menu==="mens"?        <hr/> : <></> } </li>
                <li onClick={()=> {handleItemClick("womens")}}> <Link style = {{textDecoration:"None", color:"rgb(17, 17, 17)"}} to = '/women' >Women</Link>   {menu==="womens"?      <hr/> : <></> } </li>
                <li onClick={()=> {handleItemClick("kids")}}> <Link style = {{textDecoration:"None", color:"rgb(7, 7, 7)"}} to = '/kids' >Kids</Link>       {menu==="kids"?        <hr/> : <></> } </li>
           </ul>
           <div className="nav-login-cart">
                {/* <Link style = {{textDecoration:"None"}} to = '/login'><button>Login</button></Link> */}
                <Link style = {{textDecoration:"None"}} to = '/cart' ><img src = {cart} alt="#" /></Link>
                <div className='nav-cart-count'>{totalCartItems}</div>
           </div>
        </div>
        
    )
}

export default Navbar;
